import { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Tooltip } from "antd";

interface ProjectProfilesExpandedRowProps {
  projects?: API_ProjectShortInfo[];
  title: string;
  passiveMemberTooltip: string;
  archivedProjectTooltip: string;
}

export const ProjectProfilesExpandedRow: FC<ProjectProfilesExpandedRowProps> = ({
  projects = [],
  title,
  passiveMemberTooltip,
  archivedProjectTooltip,
}) => {
  const renderInfoIconIfNeeded = (project: API_ProjectShortInfo) => {
    const tooltips: string[] = [];

    if (project.role === "INFO") {
      tooltips.push(passiveMemberTooltip);
    }

    if (project.archive) {
      tooltips.push(archivedProjectTooltip);
    }

    if (!tooltips.length) {
      return null;
    }

    return (
      <Tooltip title={tooltips.join("\n")} styles={{ root: { maxWidth: 400, whiteSpace: "pre-line" } }}>
        <FontAwesomeIcon className="ml-sm" size="lg" color="#45bfb1" icon={["far", "info-circle"]} fixedWidth={true} />
      </Tooltip>
    );
  };

  return (
    <div style={{ paddingLeft: 50 }}>
      <Card size="small" title={title}>
        {projects.map((project) => (
          <div style={{ marginBottom: 3 }} key={project.id} className="flex items-center">
            {project.name} (PID: {project.id}) {renderInfoIconIfNeeded(project)}
          </div>
        ))}
      </Card>
    </div>
  );
};
